import { RFINotifications } from '../../../cimsPage/instances/rfi'
import { Notifications } from '../../common'

const { View, Edit } = Notifications({
  edit: '682c6f06-5db3-4207-a5f6-a986d82087f2',
  view: '3afb5de1-1797-4d49-9dd1-1cdf333222e4',
  page: RFINotifications,
})

export const ViewRFINotification = View
export const EditRFINotification = Edit

export type RFINotificationPermission =
  | typeof ViewRFINotification
  | typeof EditRFINotification
